import { render, staticRenderFns } from "./forumDetails.vue?vue&type=template&id=a68b15a8&"
import script from "./forumDetails.vue?vue&type=script&lang=js&"
export * from "./forumDetails.vue?vue&type=script&lang=js&"
import style0 from "./forumDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports